export enum OptionGroupId {
    MAGENTA_EINS = 160,
    MAGENTA_TV = 148,
    WIFI_PACKAGES = 149,
    ENTERTAINMENT_OPTIONS = 300,
}
